import { track } from '@bnnvara/analytics/src/track';
import { useBrand } from '@bnnvara/brand';
import { LikeButton as StyledLikeButton } from '@bnnvara/buttons';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './styled';
import { useLikes } from './useLikes';

export const LikeButton = ({ id, type: contentType, slug }) => {
  const { slug: brandSlug } = useBrand();
  const likeType = contentType === 'article' ? 'publication' : contentType;
  const { isLikedByUser, isReady, likeCount, toggle } = useLikes({
    brandSlug,
    contentType,
    id,
    slug,
    likeType,
  });
  const disable = !isReady;

  function handleClick() {
    const result = toggle();

    if (result === null) {
      return;
    }

    const label = `${result === false ? 'undo-' : ''}like-${likeType}`;

    track('like-button', 'click', label);
  }

  return (
    <S.StyledLikeButtonContainer>
      <StyledLikeButton
        disable={disable}
        onClick={handleClick}
        isLiked={isLikedByUser}
        likes={likeCount === undefined ? 0 : likeCount}
      />
    </S.StyledLikeButtonContainer>
  );
};

LikeButton.propTypes = {
  type: PropTypes.oneOf(['media', 'article']).isRequired,
  slug: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

LikeButton.defaultProps = {
  slug: null,
};
